const crf150lData = {
  slug: "crf150l",
  name: "Honda CRF150L",

  hero: {
    shortDescription:
      "Motor trail dual purpose 150cc yang tangguh, ringan, dan siap menghadapi berbagai medan",

    variants: [
      {
        key: "black",
        label: "Extreme",
        fullName: "Honda CRF150L Extreme Black",
        startPrice: 38809000,
      },
      {
        key: "green",
        label: "Extreme",
        fullName: "Honda CRF150L Extreme Green",
        startPrice: 38809000,
      },
      {
        key: "red",
        label: "Extreme",
        fullName: "Honda CRF150L Extreme Red",
        startPrice: 38809000,
      },
      {
        key: "white",
        label: "Extreme",
        fullName: "Honda CRF150L Extreme White",
        startPrice: 38809000,
      },
    ],

    slides: [
      {
        variantKey: "black",
        image: "/assets/motor/produk/crf150l/Honda-CRF150L-Extreme-Black-1024x1002.webp",
        specs: {
          engine: "149,15 cc, 4 Langkah, SOHC, Pendingin Udara",
          power: "9,51 kW (12,9 PS) / 8.000 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "green",
        image: "/assets/motor/produk/crf150l/Honda-CRF150L-Extreme-Green-1024x1002.webp",
        specs: {
          engine: "149,15 cc, 4 Langkah, SOHC, Pendingin Udara",
          power: "9,51 kW (12,9 PS) / 8.000 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "red",
        image: "/assets/motor/produk/crf150l/Honda-CRF150L-Extreme-Red-1024x1002.webp",
        specs: {
          engine: "149,15 cc, 4 Langkah, SOHC, Pendingin Udara",
          power: "9,51 kW (12,9 PS) / 8.000 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "white",
        image: "/assets/motor/produk/crf150l/Honda-CRF150L-Extreme-White-1024x1002.webp",
        specs: {
          engine: "149,15 cc, 4 Langkah, SOHC, Pendingin Udara",
          power: "9,51 kW (12,9 PS) / 8.000 rpm",
          smartKey: false,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CRF150L merupakan motor trail dual purpose yang dirancang untuk menaklukkan berbagai kondisi jalan, mulai dari aspal hingga medan off-road.",
      },
      {
        type: "paragraph",
        text:
          "Ditenagai mesin 150cc berpendingin udara dengan sistem injeksi PGM-FI, CRF150L menawarkan karakter mesin yang halus, tangguh, dan mudah dikendalikan.",
      },
      {
        type: "heading",
        text: "Desain Off-Road Tangguh",
      },
      {
        type: "paragraph",
        text:
          "Rangka kokoh, ground clearance tinggi, serta suspensi panjang memberikan kenyamanan dan kontrol optimal saat melibas jalur tanah maupun berbatu.",
      },
      {
        type: "heading",
        text: "Siap untuk Petualangan",
      },
      {
        type: "paragraph",
        text:
          "Dengan ban dual purpose, velg jari-jari, dan bobot yang ringan, Honda CRF150L siap digunakan untuk hobi off-road maupun aktivitas harian.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      [
        "Tipe Mesin",
        "4 Langkah, SOHC, Pendingin Udara",
      ],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "149,15 cc"],
      ["Daya Maksimum", "9,51 kW (12,9 PS) / 8.000 rpm"],
      ["Torsi Maksimum", "12,43 Nm / 6.500 rpm"],
      ["Transmisi", "Manual, 5 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Semi Double Cradle"],
      ["Suspensi Depan", "Upside Down (USD)"],
      ["Suspensi Belakang", "Pro-Link Monoshock"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Cakram"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "2.119 x 793 x 1.153 mm"],
      ["Tinggi Jok", "869 mm"],
      ["Jarak Sumbu Roda", "1.375 mm"],
      ["Berat", "122 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "7,2 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "DC-CDI"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CRF150L",
    items: [
      {
        title: "Mesin 150cc Tangguh",
        desc:
          "Mesin berpendingin udara yang handal, irit bahan bakar, dan mudah perawatannya.",
      },
      {
        title: "Upside Down Front Suspension",
        desc:
          "Suspensi depan USD untuk handling lebih stabil di medan off-road.",
      },
      {
        title: "Pro-Link Rear Suspension",
        desc:
          "Suspensi belakang Pro-Link untuk kenyamanan dan daya redam optimal.",
      },
      {
        title: "Rangka Semi Double Cradle",
        desc:
          "Rangka kokoh yang mendukung kestabilan saat melewati berbagai medan.",
      },
      {
        title: "Velg Jari-jari & Ban Dual Purpose",
        desc:
          "Siap digunakan di jalan raya maupun jalur off-road.",
      },
      {
        title: "Desain Extreme Style",
        desc:
          "Tampilan agresif dengan grafis khas motor trail Honda.",
      },
    ],
  },
};

export default crf150lData;
